import React from 'react'
import { Navbar, DB_Header, Contenido, Votar, ComentariosR, Blogs_relacionados} from '../container';
import FooterPrime from '../container/Footer/Footer';
import '../App.css';

import { useAxios } from '../hooks/useAxios';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const DetalleGuid2 = () => {
  const { friendly } = useParams();

  const [t, i18n] = useTranslation("global");
  const { data, isLoading, error } = useAxios(`/blogs/by-guid/${ friendly }?lang=${ i18n.language }`);
  // const { data, isLoading, error } = useAxios(`/blogs/by-friendly/${ friendly }?lang=en`);
  const { titulo, categorias, fecha, resumen, contenidoHtml, blogsRelacionados, comentarios, tag, urlImagen, guid } = !!data && data;


  console.log(error);
  return (
    <>
      {
      ( isLoading )
      ? ( <h1> Loading...</h1>)
      : (
        <div className='App_DB'>
          <Navbar/>
            <DB_Header titulo={ titulo } categorias={ categorias } urlImagen={ urlImagen } fecha={ fecha } resumen={ resumen }/>
            <Contenido contenidoHtml={ contenidoHtml } titulo={ titulo }/>
            <Votar friendlyTag={friendly}/>
            <ComentariosR comentarios={comentarios} friendlyTag={tag} guid={guid} titulo={titulo} />
            <Blogs_relacionados blogsRelacionados={ blogsRelacionados } categorias={ categorias }/>
            <FooterPrime/>
        </div>
        )
      }
    </>
  )
}

export default DetalleGuid2
